/* eslint-disable import/no-anonymous-default-export */
const Data = [
  {
    id: 1,
    title: "Parthenon",
    location: "GREECE",
    googleMapsUrl: "https://goo.gl/maps/a2UaeW8LQQ6RvxD3A",
    natural: false,
    dateBuilt: "438 BC",
    description:
      "The Parthenon is a former temple on the Athenian Acropolis, regarded as an enduring symbol of Ancient Greece, democracy and Western civilization, and one of the world's greatest cultural monuments.",
    imageUrl: "https://source.unsplash.com/ilQmlVIMN4c",
  },
  {
    id: 2,
    title: "Mount Fuji",
    location: "Japan",
    googleMapsUrl: "https://goo.gl/maps/1DGM5WrWnATgkSNB8",
    natural: true,
    dateBuilt: "",
    description:
      "Mount Fuji is the tallest mountain in Japan, standing at 3,776 meters (12,380 feet). Mount Fuji is the single most popular tourist site in Japan, for both Japanese and foreign tourists.",
    imageUrl: "https://source.unsplash.com/WLxQvbMyfas",
  },
  {
    id: 3,
    title: "Sydney Opera House",
    location: "Australia",
    googleMapsUrl: "https://goo.gl/maps/bvUa3DjYZLp5BeaD6",
    natural: false,
    dateBuilt: "1973",
    description:
      "The Sydney Opera House is a multi-venue performing arts centre in Sydney. It is often regarded as one of the 20th century's most famous and distinctive buildings",
    imageUrl: "https://source.unsplash.com/JmuyB_LibRo",
  },
  {
    id: 4,
    title: "Geirangerfjord",
    location: "Norway",
    googleMapsUrl: "https://goo.gl/maps/MLVd3w4bAxujF4mG7",
    natural: true,
    dateBuilt: "",
    description:
      "The Geiranger Fjord is a fjord in the Sunnmøre region of Møre og Romsdal county, Norway. It is located entirely in the Stranda Municipality. The fjord is one of Norway's most visited tourist sites.",
    imageUrl: "https://source.unsplash.com/3PeSjpLVtLg",
  },
];

export default Data;
